import React, { useState } from 'react';
import { MDEEditorExample } from '../../../Constant';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import SmallEditor from './SmallEditor';
import HeaderCard from '../../Common/HeaderCard';
import SimpleMDE from 'react-simplemde-editor';

const MdeEDitorContain = () => {
  const [text, setText] = useState(`Enter text in the area on the left. For more info, click the ? (help) icon in the menu.`);
  const handleChange = () => {
    setText('Enter text in the area on the left. For more info, click the ? (help) icon in the menu.');
  };
  return (
    <Container fluid={true}>
      <Breadcrumbs title='MDE Editor' parent='Editors' pageTitle='MDE Editor' />
      <Row>
        <Col sm='12'>
          <Card>
            <HeaderCard title={MDEEditorExample} />
            <CardBody>
              <SimpleMDE
                id='editor_container'
                onChange={handleChange}
                value={text}
                options={{
                  autofocus: true,
                  spellChecker: false,
                }}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <SmallEditor />
    </Container>
  );
};
export default MdeEDitorContain;
